import React, { PureComponent } from 'react'

import I18nMessage from '../I18nMessage'
import './BrowserSupport.scss'
import ChromeLogo from './chrome.svg'
import EdgeLogo from './edge.svg'
import FirefoxLogo from './firefox.svg'
import SafariLogo from './safari.svg'

class BrowserSupport extends PureComponent {
  render() {
    return (
      <div className="passport-ui-message">
        <div className="browser_message">
          <h1><I18nMessage id="passport.not.supported.browser.title" /></h1>
          <p className="message_description"><I18nMessage id="passport.not.supported.browser.message" /></p>
          <div className="browser_logo_group">
            <div className="browser_logo">
              <img src={ChromeLogo} alt="Chrome Logo" />
              <span><I18nMessage id="passport.not.supported.browser.chrome" /></span>
            </div>
            <div className="browser_logo">
              <img src={EdgeLogo} alt="Edge Logo" />
              <span><I18nMessage id="passport.not.supported.browser.edge" /></span>
            </div>
            <div className="browser_logo">
              <img src={FirefoxLogo} alt="Firefox Logo" />
              <span><I18nMessage id="passport.not.supported.browser.firefox" /></span>
            </div>
            <div className="browser_logo">
              <img src={SafariLogo} alt="Safari Logo" />
              <span><I18nMessage id="passport.not.supported.browser.safari" /></span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default BrowserSupport
